import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { AllStatus } from '../../../core/services/status/all-status';

@Component({
  selector: 'app-window-field',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions,MatButtonModule],
  templateUrl: './window-field.html',
  styleUrl: './window-field.scss'
})
export class WindowField {
  readonly dialogRef = inject(MatDialogRef<WindowField>);
  data = inject(MAT_DIALOG_DATA);
  public allStatus$ = inject(AllStatus);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  onNoClick(){
    this.dialogRef.close();
  }

  addOpacity(color: string):string{
    return color + 33;
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
    //}
  }

}
